import React from 'react';
import styles from './RiselioDescription.module.scss';

export function RiselioDescription() {
    return (
        <div className={styles.Description}>
            <div className="container">
                <div className={styles.Description__contents}>
                    <h2>Apa Itu Riselio</h2> <br />
                    <p>Riselio merupakan platform terbaik serta terpercaya di Indonesia yang
                    memudahkan para reseller untuk menjual produk secara online lewat Marketplace, Instagram,
                    WhatsApp, Facebook, serta media sosial lainnya.</p>
                    <p>Riselio siap meningkatkan keuntungan kamu dalam berjualan secara online dengan:</p>
                    <br />
                    <div className="row">
                        <div className="col-xl-4 text-center mb-5">
                            <div className={styles.Description__contents__highlights}>
                                <img className="img-fluid undragable" alt="diskon murah" src="./assets/discount.png" />
                                <p>Dropship Produk bermutu dengan harga grosir</p>
                            </div>
                        </div>
                        <div className="col-xl-4 text-center mb-5">
                            <div className={styles.Description__contents__highlights}>
                                <img className="img-fluid undragable" alt="pengiriman" src="./assets/delivery.png" />
                                <p>Doorstep delivery ke semua wilayah di Indonesia</p>
                            </div>
                        </div>
                        <div className="col-xl-4 text-center mb-5">
                            <div className={styles.Description__contents__highlights}>
                                <img className="img-fluid undragable" alt="terpercaya" src="./assets/payment.png" />
                                <p>Opsi pembayaran online yang aman dan terpercaya</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

